import React, { useState } from "react";
import "./login.css";
import { Form, Input, Button, Checkbox, Card, Layout, Typography } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { DeviceUUID } from "device-uuid";
import { callApi } from "../../../api/apiCaller";
import { useDispatch } from "react-redux";
import {
  accessToken,
  refreshToken,
  userData,
} from "../../../redux/userDataSlice";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../api/routes";
import Loader from "../../../components/loader/loader";
import { GreenNotify, RedNotify } from "../../../helper/helper";
import { AppLogo } from "../../../assets";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isloading, setIsLoading] = useState(false);

  const onFinish = (values) => {
    console.log("values", values);
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      let id = new DeviceUUID().get();
      localStorage.setItem("deviceId", id);
      deviceId = id;
    }

    let getRes = (res) => {
      console.log("res of login", res);
      if (res.status === 200) {
        dispatch(userData(res?.data?.user));
        dispatch(accessToken(res?.data?.token));
        dispatch(refreshToken(res?.data?.refreshToken));
        GreenNotify("Login Successfully");
        navigate("/", { replace: true });
      } else {
        RedNotify(res.message);
      }
    };
    let body = {
      email: values.email,
      password: values.password,
      role: "super-admin",
      device: { id: deviceId, deviceToken: "angg" },
    };
    callApi("POST", routes.signIn, body, setIsLoading, getRes, (error) => {});
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const { Content } = Layout;
  const { Title } = Typography;

  return (
    <Layout className="login-layout">
      <Content className="login-content">
        <Card bordered={false} className="login-card">
          {/* Logo Area */}
          <div className="login-logo-container">
            <img
              src={AppLogo}
              alt="Mulberry Tree Logo"
              className="login-logo"
            />
            <Title level={3} className="login-title">
              Erchonia Super Admin
            </Title>
          </div>

          {/* Login Form */}
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your Email Address!",
                },
                {
                  type: "email",
                  message: "The input is not a valid E-mail!",
                },
              ]}
            >
              <Input
                // Changed icon to MailOutlined
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Email Address"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your Password!",
                },
              ]}
            >
              <Input.Password // <-- Use Input.Password component
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Password"
                // The visibility toggle button is included by default!
              />
            </Form.Item>

            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>

              <a className="login-form-forgot" href="">
                Forgot password
              </a>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={isloading}
              >
                Log in
              </Button>
              {/* <div className="login-register-link">
              Or <a href="">register now!</a>
            </div> */}
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Login;
